import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { pricingElevation } from '~app/styles/theme';
import { StyleProps } from '~pricing/components/Ribbon/types';

export default createMemoStyles(({ type, palette, packageTheme }: PricingAppTheme) => ({
  RibbonStyle: {
    fontSize: 10,
    position: 'absolute',
    height: 32,
    bottom: '100%',
    zIndex: pricingElevation.plusOne,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginLeft: -2,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    border: ({ packageName }: StyleProps) => `2px solid ${packageTheme[packageName].primary}`,
    backgroundColor: palette.background.primary.medium,
    '& p': {
      fontSize: type.fontSize.body,
      fontWeight: type.fontWeight.medium,
      textAlign: 'center',
      width: '100%',
      display: 'block',
      boxShadow: 'none',
      position: 'absolute',
      margin: 0,
    },
  },
}));
